<script>
  import { _ } from 'svelte-i18n'
  import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
  } from 'sveltestrap'
  import { navigate } from 'svelte-routing'
  import { Link } from 'svelte-routing'
  import { onMount } from 'svelte'
  import { user } from '../services/user.js'
  let currentUser
  let thumbnailUrl = 'https://ui-avatars.com/api/?name=John+Doe'
  let names = 'Nombre no disponible' // Valor por defecto o mensaje de error
  onMount(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      currentUser = JSON.parse(storedUser);
      if (currentUser.new_profile && currentUser.new_profile.avatar && currentUser.new_profile.avatar.length > 0) {
        thumbnailUrl = currentUser.new_profile.avatar[0].formats.thumbnail.url;
        console.log(
          'URL de la imagen de perfil:',
          currentUser.new_profile.avatar[0]
        );
      } else {
        thumbnailUrl = 'https://ui-avatars.com/api/?name=John+Doe'; // Default if no avatar
      }

      names = currentUser.new_profile?.Name && currentUser.new_profile?.Lastname
        ? `${currentUser.new_profile.Name} ${currentUser.new_profile.Lastname}`
        : 'Nombre no disponible';
    } else {
      // User not logged in, handle default state
      thumbnailUrl = 'https://ui-avatars.com/api/?name=John+Doe';
      names = 'Nombre no disponible';
    }
  });

  function handleLogOut() {
    localStorage.removeItem('jwt');
    localStorage.removeItem('user');
    user.set(null);
    navigate('/login');
  }
</script>

<Dropdown class="dropdown d-inline-block">
  <DropdownToggle
    class="btn header-item headerbtn"
    id="page-header-user-dropdown"
    tag="button"
    color=""
  >
    <img
      class="rounded-circle header-profile-user"
      src={thumbnailUrl}
      alt="Avatar {names}"
    />
    <span class="d-none d-xl-inline-block ms-1"> Admin </span>
    <i class="mdi mdi-chevron-down d-none d-xl-inline-block" />
  </DropdownToggle>

  <DropdownMenu class="dropdown-menu-end">
    <h6 class="dropdown-header">Hola {names}</h6>
    <DropdownItem>
      <Link to="/contacts-profile">
        <i
          class="mdi mdi-account-circle text-muted font-size-16 align-middle me-1"
        />
        <span class="align-middle" key="t-profile"
          >{$_('navbar.dropdown.henry.list.profile')}</span
        >
      </Link>
    </DropdownItem>

    <div class="dropdown-divider" />
    <DropdownItem tag="a" on:click={handleLogOut}
      ><i class="mdi mdi-logout text-muted font-size-16 align-middle me-1" />
      <span class="align-middle" key="t-logout"
        >{$_('navbar.dropdown.henry.list.logout')}</span
      >
    </DropdownItem>
  </DropdownMenu>
</Dropdown>
